import React from 'react';
import './App.css';
import AddNewProductPage from './Pages/AddNewProductPage/AddNewProductPage';
import Navbar from './Components/Navbar/Navbar';

import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import Checkout from './Pages/Checkout/Checkout';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar></Navbar>
        <Routes>
          <Route path='/' element={<AddNewProductPage></AddNewProductPage>}></Route>
          <Route path='/checkout' element={<Checkout></Checkout>}></Route>

        </Routes>

      </BrowserRouter>

    </div>
  );
}

export default App;
